import React from 'react';
import HeaderTitle from 'header/components/title';

const Header = () => <HeaderTitle title="Check your email inbox" />;

export default Header;



// WEBPACK FOOTER //
// ./landing_pages/components/drip_campaign_subs_header.jsx